module.exports = __webpack_public_path__ + "img/package.d4a98109.svg";